import { isEqual } from 'lodash-es';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getOptionsRoute } from '../../../../containers/Routes/routes';
import { Options } from '../../../../containers/Trading/Markets/Options';
import { useCurrentAppLayoutId } from '../../../../hooks/useAppLayoutId';
import type { OptionsPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';
import type { LayoutPanelProps } from '../../types';

export function OptionsPanel({ api, params }: LayoutPanelProps<OptionsPanelConfig>) {
  const navigate = useNavigate();
  const layoutId = useCurrentAppLayoutId();
  const updateConfig = useCallback(
    (panelData: Partial<OptionsPanelConfig>) => {
      api.updateParameters(panelData);
      if (isEqual(params.optionFilter, panelData.optionFilter) || panelData.optionFilter == null) {
        return;
      }
      navigate(
        getOptionsRoute({
          underlyingCodeOrCurrency: panelData.optionFilter.underlyingCode ?? panelData.optionFilter.currency,
          market: panelData.optionFilter.market,
          marketAccount: panelData.optionFilter.marketAccountName ?? 'account',
          expiry: panelData.optionFilter.expiry ?? undefined,
          id: api.id,
          layoutId,
        }),
        {
          replace: true,
        }
      );
    },
    [api, navigate, params, layoutId]
  );

  return (
    <Panel panelApi={api} data-testid="options-panel">
      <Options {...params} id={api.id} updateConfig={updateConfig} />
    </Panel>
  );
}
